import React from "react";

const BoyHead = () => (
  <g data-name="Head">
    <g>
      <path
        d="M139,257.44c-.37,11.63-9.51,20.21-20.41,19.17s-19.45-11.32-19.08-22.95,9.51-20.21,20.42-19.17S139.35,245.81,139,257.44Z"
        fill="#fdd0b3"
      />
      <path
        d="M107.69,247.83s9.29-5.44,11.25,2.28c2.85,11.23,7,10.39,13.1,7.69l2,5.43s-16.93,6.93-18-7C115.42,247.41,107.69,247.83,107.69,247.83Z"
        fill="#e5a37f"
      />
    </g>
    <g>
      <path
        d="M343.69,257.44c.37,11.63,9.51,20.21,20.42,19.17s19.44-11.32,19.07-22.95-9.51-20.21-20.41-19.17S343.32,245.81,343.69,257.44Z"
        fill="#fdd0b3"
      />
      <path
        d="M375,247.83s-9.29-5.44-11.25,2.28c-2.85,11.23-7,10.39-13.1,7.69l-2,5.43s16.93,6.93,18-7C367.26,247.41,375,247.83,375,247.83Z"
        fill="#e5a37f"
      />
    </g>
    <rect
      x="129.34"
      y="144.52"
      width="224.77"
      height="202.66"
      rx="88"
      ry="88"
      fill="#fdd0b3"
    />
    <path
      d="M232.61,188.66s24.67,25.14,71.22,27.93c0,0-3.72-7-20.95-20S241,180.75,232.61,188.66Z"
      fill="#5e3017"
    />
    <path
      d="M158.91,189.82s-7.54,41.37-27.12,60c0,0-11.06-17.52-9.14-31.54,0,0-2.84,3.89-5.38,5.53,0,0-11.44-17.73,6.8-38.67S155.92,172.92,158.91,189.82Z"
      fill="#5e3017"
    />
    <path
      d="M324.85,192.55s7.54,41.36,27.12,60c0,0,16.68-25.28,12.12-44.41C364.09,208.18,327.84,175.65,324.85,192.55Z"
      fill="#5e3017"
    />
    <g>
      <circle cx="195.07" cy="249.85" r="13.85" fill="#262626" />
      <circle cx="199.07" cy="247.08" r="5.54" fill="#fff" />
      <path
        d="M209.77,228.74s-27.51-2.29-31.33-9.17-4.58-18.34,3.06-15.28,26.6,15.64,29,17.05C212.19,222.38,215.12,228.74,209.77,228.74Z"
        fill="#5e3017"
      />
    </g>
    <g>
      <circle cx="287.2" cy="249.85" r="13.85" fill="#262626" />
      <circle cx="283.2" cy="247.08" r="5.54" fill="#fff" />
      <path
        d="M272.5,228.74s27.51-2.29,31.33-9.17,4.58-18.34-3.06-15.28-26.6,15.64-29,17.05C270.08,222.38,267.15,228.74,272.5,228.74Z"
        fill="#5e3017"
      />
    </g>
    <g>
      <circle cx="170.59" cy="285.79" r="12.83" fill="#fdc1b3" />
      <circle cx="312.86" cy="285.79" r="12.83" fill="#fdc1b3" />
    </g>
    <path
      d="M239.52,284.17c-7.76,0-14.19-5-15.51-11.47a12.51,12.51,0,0,0-.26,2.46c0,7.7,7.06,13.93,15.77,13.93s15.77-6.24,15.77-13.93a12.36,12.36,0,0,0-.26-2.46C253.71,279.21,247.28,284.17,239.52,284.17Z"
      fill="#e5a37f"
    />
    <g>
      <path
        d="M239.12,326.15c-12,0-21.81-8.52-21.81-19,0-4,1.57-6,4.79-6a26.78,26.78,0,0,1,6.32,1.23,41.66,41.66,0,0,0,10.91,1.87,40.41,40.41,0,0,0,10.84-1.89,25.38,25.38,0,0,1,6.1-1.21c4.66,0,4.66,4.53,4.66,6C260.93,317.62,251.15,326.15,239.12,326.15Z"
        fill="#ff706f"
      />
      <path
        d="M256.28,302.23c2.25,0,3.56,1.16,3.56,4.92,0,9.88-9.27,17.9-20.71,17.9s-20.71-8-20.71-17.9c0-3.75,1.37-4.92,3.69-4.92,3.79,0,10.13,3.1,17.23,3.1s13.28-3.1,16.95-3.1m0-2.2h0a26,26,0,0,0-6.4,1.25,39.56,39.56,0,0,1-10.55,1.85,40.83,40.83,0,0,1-10.62-1.83A27.36,27.36,0,0,0,222.1,300c-2.69,0-5.89,1.24-5.89,7.12,0,11.08,10.28,20.1,22.91,20.1s22.91-9,22.91-20.1c0-5.88-3.13-7.12-5.76-7.12Z"
        fill="#a56646"
      />
    </g>
    <path
      d="M239.33,305.34c-11.44,0-20.92-8.07-20.92,1.81a15.57,15.57,0,0,0,.34,3.13c5,2.41,11.8,3.91,19.37,3.91,8.78,0,16.59-2,21.59-5.13a15.3,15.3,0,0,0,.12-1.9C259.83,297.27,250.76,305.34,239.33,305.34Z"
      fill="#fff"
    />
    <path
      d="M153.22,178.14s30.55,17.11,51.93,15.88a23.31,23.31,0,0,0-14.66-17.11s76.41,39.64,113.35,39.68c0,0-33.93-36.62-50.42-39.07,0,0,40.93,18.94,53.76,18.94,0,0-3.05-11.61-10.39-18.94,0,0,56.21,32.38,64.76,31.16S313.29,144.53,273,140.87,171.55,145.75,153.22,178.14Z"
      fill="#5e3017"
    />
    <path
      d="M145.89,174.47s-15.88-22.61,5.5-40.32,103.86-42.77,159.46-14.66,67.82,82.48,47,117.91c0,0-12.83-47-36-56.21s-150.9-11.61-156.4-7.33-14.66,8.55-18.33,6.72S145.89,174.47,145.89,174.47Z"
      fill="#5e3017"
    />
  </g>
)

export default BoyHead;


// WEBPACK FOOTER //
// ./src/components/Pirate/parts/BoyHead.js